import { FormValues } from './types';

export const normalizeDate = (value: unknown): Date | undefined => {
  if (!value) return undefined;
  if (value instanceof Date) return value;
  if (typeof (value as { toDate?: () => Date }).toDate === 'function') {
    const asDate = (value as { toDate: () => Date }).toDate();
    return Number.isNaN(asDate?.getTime()) ? undefined : asDate;
  }

  const parsed = new Date(value as string);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
};

export const truncateToDate = (value: unknown): Date | undefined => {
  const date = normalizeDate(value);
  if (!date) return undefined;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

export const datesMatch = (a: unknown, b: unknown) => {
  const left = truncateToDate(a);
  const right = truncateToDate(b);
  if (!left || !right) return false;
  return (
    left.getFullYear() === right.getFullYear() &&
    left.getMonth() === right.getMonth() &&
    left.getDate() === right.getDate()
  );
};

export const validate = (values: FormValues) => {
  const errors: Record<string, string> = {};

  if (!values.dateRange) {
    errors.dateRange = 'Select a range';
  }

  const start = values.startDate ? new Date(values.startDate) : null;
  const end = values.endDate ? new Date(values.endDate) : null;

  if (!values.startDate) {
    errors.startDate = 'Start date is required';
  } else if (Number.isNaN(start?.getTime())) {
    errors.startDate = 'Start date is invalid';
  }

  if (!values.endDate) {
    errors.endDate = 'End date is required';
  } else if (Number.isNaN(end?.getTime())) {
    errors.endDate = 'End date is invalid';
  }

  if (start && end && start > end) {
    errors.endDate = 'End date must be on/after start date';
  }

  return errors;
};

// A report requires a specific client; 0 (super's ALL) and null/undefined are not valid targets.
export const hasInvalidClientId = (clientId: number | null | undefined): boolean =>
  !Number.isInteger(clientId) || (clientId as number) <= 0;
